module.exports = __webpack_public_path__ + "img/zoom-pegasus-turbo-shield-womens-running-shoe-TP4DR2.98258b8d.png";